import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
};

const pre = "dashboard-";

export default {
  path: "/dashboard",
  name: "dashboard",
  redirect: {
    name: `${pre}console`,
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "console",
      name: `${pre}console`,
      meta: {
        ...meta,
        title: "工作台",
      },
      component: () => {
        if (JSON.parse(localStorage.getItem("isDept"))) {
          //承办单位
          return import("@/pages/dashboard/home_unit");
        } else {
          return import("@/pages/dashboard/console");
        }
      },
    },
    // {
    //     path: 'unit',
    //     name: `${pre}unit`,
    //     meta: {
    //         ...meta,
    //         title: '工作台'
    //     },
    //     component: () => import('@/pages/dashboard/home_unit')
    // },
    {
      path: "user/userInfo/:id",
      name: "userInfo",
      meta: {
        ...meta,
        title: "个人信息",
      },
      component: () => import("@/pages/dashboard/user/userInfo"),
    },
    {
      path: "user/userInfoEdit/:id",
      name: "userInfoEdit",
      meta: {
        ...meta,
        title: "编辑个人信息",
      },
      component: () => import("@/pages/dashboard/user/userInfoEdit"),
    },
    {
      path: "user/updatePassword/:id",
      name: "updatePassword",
      meta: {
        ...meta,
        title: "修改密码",
      },
      component: () => import("@/pages/dashboard/user/updatePassword"),
    },
    {
      path: "/user/updatePassword/:id/:flg",
      name: "updatePassword2",
      meta: {
        ...meta,
        title: "重置密码",
      },
      component: () => import("@/pages/dashboard/user/updatePassword"),
    },
    {
      path: "monitor",
      name: `${pre}monitor`,
      meta: {
        ...meta,
        title: "监控页",
      },
      component: () => import("@/pages/dashboard/monitor"),
    },
    {
      path: "workplace",
      name: `${pre}workplace`,
      meta: {
        ...meta,
        title: "主控页",
      },
      component: () => import("@/pages/dashboard/workplace"),
    },
    {
      path: "/doc",
      name: `doc`,
      meta: {
        auth: false,
        cache: true,
        title: "文档页",
      },
      component: () => import("@/pages/dashboard/ifame/doc.vue"),
    },
  ],
};
